var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7203,
    cy: 11,
    rx: 10.7203,
    ry: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7204 12.5717C11.6226 12.5717 12.354 11.8212 12.354 10.8954C12.354 9.96965 11.6226 9.21918 10.7204 9.21918C9.81813 9.21918 9.08673 9.96965 9.08673 10.8954C9.08673 11.8212 9.81813 12.5717 10.7204 12.5717Z",
    fill: "#E7393D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8219 10.7529C16.3416 9.47801 15.5077 8.37546 14.4233 7.58153C13.3389 6.78761 12.0515 6.33713 10.7203 6.28577C9.38914 6.33713 8.10179 6.78761 7.0174 7.58153C5.93301 8.37546 5.0991 9.47801 4.61875 10.7529C4.58631 10.845 4.58631 10.9458 4.61875 11.0379C5.0991 12.3128 5.93301 13.4154 7.0174 14.2093C8.10179 15.0032 9.38914 15.4537 10.7203 15.5051C12.0515 15.4537 13.3389 15.0032 14.4233 14.2093C15.5077 13.4154 16.3416 12.3128 16.8219 11.0379C16.8543 10.9458 16.8543 10.845 16.8219 10.7529ZM10.7203 13.6193C10.1953 13.6193 9.68205 13.4596 9.24549 13.1602C8.80894 12.8609 8.46869 12.4355 8.26777 11.9378C8.06684 11.4401 8.01427 10.8924 8.1167 10.364C8.21913 9.83563 8.47196 9.35028 8.84322 8.96934C9.21448 8.5884 9.68749 8.32897 10.2024 8.22387C10.7174 8.11877 11.2511 8.17271 11.7362 8.37888C12.2213 8.58504 12.6359 8.93417 12.9276 9.38211C13.2193 9.83005 13.375 10.3567 13.375 10.8954C13.3739 11.6175 13.0939 12.3097 12.5962 12.8203C12.0986 13.3309 11.4241 13.6182 10.7203 13.6193Z",
    fill: "#E7393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.4d19a5c048722a1760a4da1d105399c1.svg";
export { ForwardRef as ReactComponent };